// written in javascript so gatsby-node can use it
// @ts-ignore
exports.buildFaqUrlSlug = (faqGroup, faqQuestion) => {
    const nonAlphanumeric = /[^A-Za-z0-9 ]*/g;
    const cleanedGroup = faqGroup.toLowerCase().replace(nonAlphanumeric, '').replace(/\s/g, '-');
    const cleanedQuestion = faqQuestion.toLowerCase().replace(nonAlphanumeric, '').replace(/\s/g, '-');

    return `faq/${cleanedGroup}/${cleanedQuestion}`;
};
